"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusDropdown = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _StatusIndicator = _interopRequireDefault(require("@civicplus/preamble/lib/StatusIndicator"));

var _ButtonDropDown = _interopRequireDefault(require("@civicplus/preamble/lib/ButtonDropDown/ButtonDropDown"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var StatusDropdown = function StatusDropdown(props) {
  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      actions = _useState2[0],
      setActions = _useState2[1];

  (0, _react.useEffect)(function () {
    setActions(buildActions()); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.permissions, props.saveDisabled, props.disabled]);
  (0, _react.useEffect)(function () {
    if (actions) {
      actions.length === 0 ? props.onNoAccess() : props.onHasAccess();
    } // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [actions]);

  function buildActions() {
    var _props$permissions2, _props$item$scheduleJ;

    var actions = [];

    if (props.isNew && props.permissions.canCreate || props.permissions.canUpdate) {
      actions.push({
        children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Save"),
        color: "primary",
        disabled: props.saveDisabled || props.disabled,
        onClick: function onClick() {
          props.onSave();
        }
      });
    }

    if (props.permissions.canCreateAndPublish) {
      var _props$permissions$st, _props$permissions;

      var published = (_props$permissions$st = (_props$permissions = props.permissions) === null || _props$permissions === void 0 ? void 0 : _props$permissions.statusUpdates.find(function (w) {
        return w.status === "Published";
      })) !== null && _props$permissions$st !== void 0 ? _props$permissions$st : {
        status: "Published",
        color: "#4caf50"
      };
      actions.push({
        color: "default",
        disabled: props.disabled,
        children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Save and change to", " ", /*#__PURE__*/_react["default"].createElement(_StatusIndicator["default"], {
          status: "CUSTOM",
          shape: "circle",
          color: published.color,
          showText: false,
          customText: published.status
        }), " ", published.status),
        onClick: function onClick() {
          props.onStatusChange(published);
        }
      });
    }

    if (props.permissions.canDraftCreate) {
      actions.push({
        color: "default",
        children: "Create New Version",
        disabled: props.disabled,
        onClick: function onClick() {
          props.onCreateDraft();
        }
      });
    }

    (_props$permissions2 = props.permissions) === null || _props$permissions2 === void 0 ? void 0 : _props$permissions2.statusUpdates.filter(function (x) {
      return props.isNew && x.status !== "Draft" || !props.isNew;
    }).forEach(function (u) {
      actions.push({
        color: "default",
        disabled: props.disabled,
        children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Save and change to", " ", /*#__PURE__*/_react["default"].createElement(_StatusIndicator["default"], {
          status: "CUSTOM",
          shape: "circle",
          color: u.color,
          showText: false,
          customText: u.status
        }), " ", u.status),
        onClick: function onClick() {
          props.onStatusChange(u);
        }
      });
    });

    if ((_props$item$scheduleJ = props.item.scheduleJob) !== null && _props$item$scheduleJ !== void 0 && _props$item$scheduleJ.dueTime) {
      actions.push({
        color: "default",
        children: "Edit Schedule",
        disabled: props.disabled,
        onClick: function onClick() {
          if (props.item.scheduleJob) props.onEditSchedule(props.item.scheduleJob);
        }
      });
      actions.push({
        color: "default",
        children: "Clear Schedule",
        disabled: props.disabled,
        onClick: function onClick() {
          if (props.item.scheduleJob) props.onClearSchedule(props.item.scheduleJob);
        }
      });
    }

    return actions;
  }

  var Buttons = function Buttons() {
    if (actions == null) {
      return /*#__PURE__*/_react["default"].createElement(_Loader["default"], null);
    }

    if (actions && actions.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        disabled: true
      }, "Save");
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "prmbl-statusDropdown",
      style: {
        marginBottom: ".7em"
      }
    }, !props.saving && /*#__PURE__*/_react["default"].createElement(_ButtonDropDown["default"], {
      options: actions
    }), props.saving && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      disabled: true
    }, "Saving..."));
  };

  if (props.portal) {
    var portalTarget = document.getElementById(props.portal);
    if (portalTarget) return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(Buttons, null), portalTarget);
  }

  return /*#__PURE__*/_react["default"].createElement(Buttons, null);
};

exports.StatusDropdown = StatusDropdown;